import React from 'react';
import CSSModules from 'react-css-modules';
import style from './card-content.scss';
import omit from 'lodash/omit';

const CardContent = ({ children, ...rest }) => (
  <div styleName={`root ${rest.extraPadding && 'extra-padding' || ''}`} {...omit(rest, 'styles', 'extraPadding')}>
    {children}
  </div>
);

export default CSSModules(CardContent, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/card-content.js